// select2's default matcher finds the term anywhere in the option text, so "bur" matches
// "Ashburton" before "Burnside". Anchor the search to the start of the name instead, ignoring
// case and macrons so "te pa" matches "Te Pā".
function searchable(text) {
  return text.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
}

function startsWithMatcher(params, data) {
  const term = searchable($.trim(params.term || ''));
  if (term === '') return data;
  if (typeof data.text === 'undefined') return null;

  return searchable(data.text).startsWith(term) ? data : null;
}

document.addEventListener("turbolinks:load", function() {
  $('[data-select-organisation]').select2({matcher: startsWithMatcher});
  $('[data-select-two]').select2();

  $('[data-select-organisation]').change((function(_this) {
    return function(e) {
      let organisation_id;
      organisation_id = $(e.target).val();
      window.location.href = location.protocol + '//' + location.host + '?' + `organisation_id=${organisation_id}`;
    };
  })(this));
});
